<template>
    <div class="layout">
        <div class="cabinet-page_bg"></div>

        <Header/>

        <div class="header-wrapper" id="header">

            <VideoIndex/>

            <div class="header">
                <div class="header-inner">
                    <div class="header-title">
                        Your <br>
                        last <br>
                        <div class="text-anim-block anim">
                            <div class="text-anim-first">WORD</div>
                            <div class="text-anim-word">
                                <div class="word word1">WORD</div>
                                <div class="word word2">WISH</div>
                            </div>
                        </div>
                    </div>
                    <div class="header-desc">Сервис для отправки отложенных сообщений вашим родным и&nbsp;близким, если с&nbsp;Вами
                        <span>что-нибудь</span> случится
                    </div>
                    <button @click="ym(80365885,'reachGoal','SignUpFreeHeader')" v-show="!userLoggedIn" class="button button-dark modal-reg">Зарегистрироваться бесплатно
                    </button>
                </div>
                <div class="scroll-icon">
                    <button type="button" class="scroll_down" id="scroll_down"></button>
                    <div class="scroll-icon-text">Вниз</div>
                </div>
            </div>
        </div>

        <div class="about-wrapper" id="about">
            <div class="about">

                <div class="title">О сервисе</div>
                <div class="desc">
                    Наш сервис поможет Вам создать сообщение, которое будет отправлено только в&nbsp;случае
                    подтверждения Вашей смерти. Вы&nbsp;можете создать аудио/видео или текстовое сообщение вашим родным
                    и&nbsp;близким людям, а&nbsp;мы&nbsp;позаботимся о&nbsp;том, что&nbsp;бы оно было доставлено, когда
                    Вас уже не&nbsp;станет.
                </div>

                <div class="about-list">
                    <div class="about-item">
                        <div class="about-item__icon">
                            <GrandIcon/>
                        </div>
                        <div class="about-item__text">
                            Хотите оставить последнее напутствие Вашим детям и&nbsp;внукам? Запишите видео-сообщение, к&nbsp;которому
                            они определенно прислушаются.
                        </div>
                    </div>
                    <div class="about-item">
                        <div class="about-item__icon">
                            <BusinessmanIcon/>
                        </div>
                        <div class="about-item__text">
                            Вы&nbsp;владелец бизнеса и&nbsp;боитесь, что он&nbsp;канет в&nbsp;лету вместе
                            с&nbsp;Вами?<br> Запишите видео-сообщение вашим коллегам и&nbsp;партнерам, отдайте им&nbsp;свои
                            последние указы и&nbsp;наставления.
                        </div>
                    </div>
                    <div class="about-item">
                        <div class="about-item__icon">
                            <FamilyIcon/>
                        </div>
                        <div class="about-item__text">
                            Хотите поздравить Вашего любимого сына или дочь с&nbsp;важным событием (совершеннолетие,
                            свадьба, рождение внуков/правнуков), но&nbsp;не&nbsp;уверены, что доживете до&nbsp;этого
                            прекрасного дня? Мы&nbsp;передадим Ваше поздравление. Только создайте его!
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <div class="functional-wrapper" id="functional">
            <div class="functional">

                <div class="title">Функционал</div>

                <div class="functional-carousel-wrapper">
                    <div class="functional-carousel-overlay"></div>
                    <div class="functional-carousel" ref="carousel">

                        <div class="functional-item">
                            <div class="functional-item-inner">
                                <div class="functional-item__video">
                                    <video poster="@/img/video-cover__son.jpg" preload="none" playsinline=""
                                           loop="loop" controls>
                                        <source src="@/video/functional__son.mp4" type="video/mp4">
                                        <source src="@/video/functional__son_1.webm" type="video/webm">
                                    </video>
                                </div>
                            </div>
                        </div>

                        <div class="functional-item">
                            <div class="functional-item-inner">
                                <div class="functional-item__video">
                                    <video poster="@/img/video-cover__pavlenko.jpg" preload="none" playsinline="" loop="loop" controls>
                                        <!-- <source src="./video/functional__son.ogv" type="video/ogv"> -->
                                        <source src="@/video/functional__pavlenko.mp4" type="video/mp4">
                                        <!-- <source src="./video/functional__son.webm" type="video/webm"> -->
                                    </video>
                                </div>
                            </div>
                        </div>

                        <div class="functional-item">
                            <div class="functional-item-inner">
                                <div class="functional-item__video">
                                    <video poster="@/img/video-cover__tony.jpg" preload="none" playsinline=""
                                           loop="loop" controls>
                                        <source src="@/video/functional__tony.mp4" type="video/mp4">
                                        <source src="@/video/functional__tony_1.webm" type="video/webm">
                                    </video>
                                </div>
                            </div>
                        </div>

                        <div class="functional-item">
                            <div class="functional-item-inner">
                                <div class="functional-item__video">
                                    <video poster="@/img/video-cover__tony-2.jpg" preload="none" playsinline=""
                                           loop="loop" controls>
                                        <source src="@/video/functional__tony-2.mp4" type="video/mp4">
                                        <source src="@/video/functional__tony-2.webm" type="video/webm">
                                    </video>
                                </div>
                            </div>
                        </div>


                    </div>
                </div>

                <div class="functional-list__control">
                    <button class="btn-control control-prev">
                        <svg viewBox="0 0 138 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M2 12H138M2 12L13.4519 23M2 12L13.4519 1" stroke="#fff" stroke-width="2"/>
                        </svg>
                    </button>
                    <button class="btn-control control-next">
                        <svg viewBox="0 0 138 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M136 12L-9.61651e-07 12M136 12L124.548 0.999999M136 12L124.548 23" stroke="#fff"
                                  stroke-width="2"/>
                        </svg>
                    </button>
                </div>

            </div>
        </div>


        <div class="subscription-wrapper" id="subscription">
            <div class="subscription">
                <div class="title">Подписка</div>
                <div class="desc">
                    30 рублей в месяц за оформление подписки на 1 письмо
                </div>
                <div class="subscription-list">
                    <div class="subscription-item">1<br> письмо</div>
                    <div class="subscription-item">1<br> день</div>
                    <div class="subscription-item">1<br> рубль</div>
                </div>
                <div class="button-wrapper">
                    <button @click="ym(80365885,'reachGoal','SignUpFreeContent')" v-show="!userLoggedIn" class="button button-border modal-reg">Зарегистрироваться бесплатно
                    </button>
                </div>
            </div>
        </div>


        <Contacts/>

        <Footer/>
        <AuthorizationWindow/>
    </div>
</template>


<script>

    import Header from '@/components/Header';
    import Footer from '@/components/Footer';
    import Contacts from '@/components/Contacts';
    import slick from '../plugins/slick/slick';
    import anime from '@/js/anime.min.js';
    import Registration from "../components/windows/Registration";
    import Login from "../components/windows/Login";
    import PasswordForgot from "../components/windows/PasswordForgot";
    import AuthorizationWindow from "../components/windows/AuthorizationWindow";
    import VideoIndex from "../components/VideoIndex";
    import FamilyIcon from "../components/icons/FamilyIcon";
    import BusinessmanIcon from "../components/icons/BusinessmanIcon";
    import GrandIcon from "../components/icons/GrandIcon";

    let activated;
    export default {

        name: 'Index',


        components: {
            GrandIcon,
            BusinessmanIcon,
            FamilyIcon,
            VideoIndex,
            AuthorizationWindow,
            PasswordForgot,
            Login,
            Registration,
            Header, Footer, Contacts, anime, slick
        },

        metaInfo: {
            title: 'Your Last Word',
        },


        beforeCreate() {
            $('body').attr('class', 'main-page index-layout');
        },

        mounted() {

            $(window).scroll(function(){
                $('.scroll-icon').addClass('competed', $(this).scrollTop() > 100);
            });

            // carousel
            if ($('.functional div').is('.functional-carousel')) {
                $('.functional-carousel').slick({
                    infinite: true,
                    slidesToShow: 1,
                    variableWidth: true,
                    prevArrow: $('.btn-control.control-prev'),
                    nextArrow: $('.btn-control.control-next')
                });
            }

            $('.functional video').bind('play', function() {
                activated = this;
                $('.functional video').each(function() {
                    if(this != activated) this.pause();
                });
            });


            if (this.$route.query.login) {
                $('.modal-auth').click();
            }

            // scroll
            $('.main-page .top-nav a, .main-page .nav-m ob-wrapper a').click(function (e) {
                e.preventDefault();
                var full_url = this.href;
                var parts = full_url.split('#');
                var trgt = parts[1];
                var target_offset = $('#' + trgt).offset();
                var target_top = target_offset.top;
                $('html, body').animate({scrollTop: target_top}, 200);
            });


            // animate
            if ($('div.text-anim-block').is('.anim')) {
                anime.timeline({loop: true})
                    .add({
                        targets: '.word1',
                        opacity: [1, 0],
                        // scaleX: [1, 0],
                        translateX: [0, '-300px'],
                        easing: "easeInOutSine",
                        duration: 500,
                        delay: 2000
                    }).add({
                    targets: '.word2',
                    opacity: [0, 1],
                    // scaleX: [0, 1],
                    translateX: ['300px', 0],
                    easing: "easeInOutSine",
                    duration: 500
                }).add({
                    targets: '.word2',
                    opacity: [1, 0],
                    // scaleX: [1, 0],
                    translateX: [0, '-300px'],
                    easing: "easeInOutSine",
                    duration: 500,
                    delay: 2000
                }).add({
                    targets: '.word1',
                    opacity: [0, 1],
                    // scaleX: [0, 1],
                    translateX: ['300px', 0],
                    easing: "easeInOutSine",
                    duration: 500
                });
            }


        },

        computed: {
            userLoggedIn() {
                let token = this.$store.getters.token;
                return !!token && token.length > 0;
            }
        }
    }
</script>
